import enAnalytics from './locales/en/analytics.json';
import enAuth from './locales/en/auth.json';
import enApiErrors from './locales/en/apiErrors.json';
import enCommon from './locales/en/common.json';
import enCustomers from './locales/en/customers.json';
import enDates from './locales/en/dates.json';
import enFinance from './locales/en/finance.json';
import enItems from './locales/en/items.json';
import enNavigation from './locales/en/navigation.json';
import enOrders from './locales/en/orders.json';
import enRecipes from './locales/en/recipes.json';
import enSettings from './locales/en/settings.json';
import enHome from './locales/en/home.json';
import enLanding from './locales/en/landing.json';
import enRegistration from './locales/en/registration.json';
import enAdmin from './locales/en/admin.json';
import enFeedback from './locales/en/feedback.json';
import plAnalytics from './locales/pl/analytics.json';
import plAuth from './locales/pl/auth.json';
import plApiErrors from './locales/pl/apiErrors.json';
import plCommon from './locales/pl/common.json';
import plCustomers from './locales/pl/customers.json';
import plDates from './locales/pl/dates.json';
import plFinance from './locales/pl/finance.json';
import plItems from './locales/pl/items.json';
import plNavigation from './locales/pl/navigation.json';
import plOrders from './locales/pl/orders.json';
import plRecipes from './locales/pl/recipes.json';
import plSettings from './locales/pl/settings.json';
import plHome from './locales/pl/home.json';
import plLanding from './locales/pl/landing.json';
import plRegistration from './locales/pl/registration.json';
import plAdmin from './locales/pl/admin.json';
import plFeedback from './locales/pl/feedback.json';
import ruAnalytics from './locales/ru/analytics.json';
import ruAuth from './locales/ru/auth.json';
import ruApiErrors from './locales/ru/apiErrors.json';
import ruCommon from './locales/ru/common.json';
import ruCustomers from './locales/ru/customers.json';
import ruDates from './locales/ru/dates.json';
import ruFinance from './locales/ru/finance.json';
import ruItems from './locales/ru/items.json';
import ruNavigation from './locales/ru/navigation.json';
import ruOrders from './locales/ru/orders.json';
import ruRecipes from './locales/ru/recipes.json';
import ruSettings from './locales/ru/settings.json';
import ruHome from './locales/ru/home.json';
import ruLanding from './locales/ru/landing.json';
import ruRegistration from './locales/ru/registration.json';
import ruAdmin from './locales/ru/admin.json';
import ruFeedback from './locales/ru/feedback.json';
import ukAnalytics from './locales/uk/analytics.json';
import ukAuth from './locales/uk/auth.json';
import ukApiErrors from './locales/uk/apiErrors.json';
import ukCommon from './locales/uk/common.json';
import ukCustomers from './locales/uk/customers.json';
import ukDates from './locales/uk/dates.json';
import ukFinance from './locales/uk/finance.json';
import ukItems from './locales/uk/items.json';
import ukNavigation from './locales/uk/navigation.json';
import ukOrders from './locales/uk/orders.json';
import ukRecipes from './locales/uk/recipes.json';
import ukSettings from './locales/uk/settings.json';
import ukHome from './locales/uk/home.json';
import ukLanding from './locales/uk/landing.json';
import ukRegistration from './locales/uk/registration.json';
import ukAdmin from './locales/uk/admin.json';
import ukFeedback from './locales/uk/feedback.json';
export const namespaces = [
    'analytics',
    'apiErrors',
    'auth',
    'common',
    'customers',
    'dates',
    'finance',
    'items',
    'navigation',
    'orders',
    'recipes',
    'settings',
    'home',
    'landing',
    'registration',
    'admin',
    'feedback'
];
export const resources = {
    en: {
        analytics: enAnalytics,
        auth: enAuth,
        apiErrors: enApiErrors,
        common: enCommon,
        customers: enCustomers,
        dates: enDates,
        finance: enFinance,
        items: enItems,
        navigation: enNavigation,
        orders: enOrders,
        recipes: enRecipes,
        settings: enSettings,
        home: enHome,
        landing: enLanding,
        registration: enRegistration,
        admin: enAdmin,
        feedback: enFeedback,
    },
    pl: {
        analytics: plAnalytics,
        auth: plAuth,
        apiErrors: plApiErrors,
        common: plCommon,
        customers: plCustomers,
        dates: plDates,
        finance: plFinance,
        items: plItems,
        navigation: plNavigation,
        orders: plOrders,
        recipes: plRecipes,
        settings: plSettings,
        home: plHome,
        landing: plLanding,
        registration: plRegistration,
        admin: plAdmin,
        feedback: plFeedback,
    },
    ru: {
        analytics: ruAnalytics,
        auth: ruAuth,
        apiErrors: ruApiErrors,
        common: ruCommon,
        customers: ruCustomers,
        dates: ruDates,
        finance: ruFinance,
        items: ruItems,
        navigation: ruNavigation,
        orders: ruOrders,
        recipes: ruRecipes,
        settings: ruSettings,
        home: ruHome,
        landing: ruLanding,
        registration: ruRegistration,
        admin: ruAdmin,
        feedback: ruFeedback,
    },
    uk: {
        analytics: ukAnalytics,
        auth: ukAuth,
        apiErrors: ukApiErrors,
        common: ukCommon,
        customers: ukCustomers,
        dates: ukDates,
        finance: ukFinance,
        items: ukItems,
        navigation: ukNavigation,
        orders: ukOrders,
        recipes: ukRecipes,
        settings: ukSettings,
        home: ukHome,
        landing: ukLanding,
        registration: ukRegistration,
        admin: ukAdmin,
        feedback: ukFeedback,
    },
};
